import React from 'react';
import { Form } from 'react-bootstrap';

function TextInput({ name, value, type, onChange, placeholder, clas,ids, describe,onFocus,style, disabled,onKeyDown,readOnly }) {
  return (
    <Form.Control
      type={type}
      name={name}
      value={value} // state
      placeholder={placeholder}
      onChange={onChange}
      className={clas}
      id={ids}
      aria-describedby={describe}
      onFocus={onFocus}
      style={style}
      disabled={disabled}
      onKeyDown={onKeyDown}
      autoComplete='off'
      readOnly={readOnly}
    />
  );
}

export default TextInput;
